import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const faqs = [
  {
    q: "Where is Shine Space Beauty Salon located in Bur Dubai?",
    a: "We're on Khalid Bin Al Waleed Road, Al Souq Al Kabeer, Al Fahidi — in the heart of Bur Dubai, a short walk from Meena Bazaar and close to Al Fahidi and Sharaf DG metro stations. Easy to reach from Al Raffa, Al Mankhool, Karama and Oud Metha.",
  },
  {
    q: "Is Shine Space a ladies-only salon?",
    a: "Yes, completely. Shine Space is a private, ladies-only beauty salon in Bur Dubai — every client enjoys a comfortable, women-only environment with female staff.",
  },
  {
    q: "What services do you offer?",
    a: "A full ladies salon menu under one roof: hair cuts, colouring and keratin treatments, manicures, pedicures and gel nails, facials and skin care, full-body waxing, eyebrow threading, and bridal & occasion henna (mehndi).",
  },
  {
    q: "What are your opening hours?",
    a: "We are open every day from 9:30 AM. For evening appointments, message us on WhatsApp and we'll confirm the latest available slot for your service.",
  },
  {
    q: "How do I book an appointment?",
    a: "The fastest way is WhatsApp — tap the green button and we usually reply within minutes. You can also call 050 179 9925 or use the booking form on this page. Walk-ins are welcome, subject to availability.",
  },
  {
    q: "Do you do bridal henna and party packages?",
    a: "Yes! We specialise in bridal mehndi and occasion henna, and can prepare full bridal packages combining hair, nails, skin and henna. Message us on WhatsApp with your date for a custom quote.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-28 sm:py-36 border-t border-line"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-14">
        <Reveal className="lg:col-span-4">
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-gold">
            Good to Know
          </span>
          <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl text-bone leading-[1.05]">
            Questions,
            <em className="text-gold-gradient italic"> answered.</em>
          </h2>
          <p className="mt-6 text-sand leading-relaxed">
            Everything women in Bur Dubai ask us before their first visit.
            Anything else? WhatsApp us — we reply in minutes.
          </p>
        </Reveal>

        <div className="lg:col-span-8">
          {faqs.map((f, i) => (
            <Reveal key={f.q} delay={i * 0.05}>
              <div
                data-testid={`faq-item-${i}`}
                className="border-b border-line"
              >
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={open === i}
                  className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                >
                  <span className="font-serif text-xl sm:text-2xl text-bone group-hover:text-gold transition-colors duration-300">
                    {f.q}
                  </span>
                  <motion.span
                    animate={{ rotate: open === i ? 45 : 0 }}
                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    className={`shrink-0 w-10 h-10 rounded-full border flex items-center justify-center transition-colors duration-300 ${
                      open === i
                        ? "bg-gold text-ink border-gold"
                        : "border-bone/25 text-bone group-hover:border-gold group-hover:text-gold"
                    }`}
                  >
                    <Plus size={16} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p
                        data-testid={`faq-answer-${i}`}
                        className="pb-8 pr-16 text-sand leading-relaxed"
                      >
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
